import { render, staticRenderFns } from "./ShopStatus.vue?vue&type=template&id=1fab0b06&scoped=true"
import script from "./ShopStatus.vue?vue&type=script&lang=js"
export * from "./ShopStatus.vue?vue&type=script&lang=js"
import style0 from "./ShopStatus.vue?vue&type=style&index=0&id=1fab0b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab0b06",
  null
  
)

export default component.exports